export default __webpack_public_path__ + "static/media/6bf0be312ff5acb76bd5e7bf5aba3f8d.svg";